import Button from '@pinecast/common/Button';
import TextInput from '@pinecast/db-spa/forms/TextInput';
import {required} from '@pinecast/db-spa/forms/validation';
import {defineMessages, FormattedMessage} from '@pinecast/i18n';
import {Form} from 'informed';

import type {Step} from './DonationPage';
import {useGetSubscriptionCheckoutSession} from './useGetSubscriptionCheckoutSession';

const messages = defineMessages({
  copy: {
    id: 'db-spa.TipJarRequestLogin.copy',
    description: 'Copy for the user email',
    defaultMessage:
      'To ensure you can cancel your subscription in the future, we need to verify your email. Where should we send the confirmation link?',
  },
  label: {
    id: 'db-spa.TipJarRequestLogin.label',
    description: 'Label for the user email',
    defaultMessage: 'Your email',
  },
  submit: {
    id: 'db-spa.TipJarRequestLogin.submit',
    description: 'Button to verify the user email',
    defaultMessage: 'Verify email',
  },
});

const TipJarRequestLogin = ({
  amount,
  onContinue,
  slug,
}: {
  amount: number;
  onContinue: (step: Step) => void;
  slug: string;
}) => {
  const requestLogin = useGetSubscriptionCheckoutSession();
  return (
    <Form
      onSubmit={async ({values}: {values: Record<string, any>}) => {
        if (requestLogin.pending) {
          return;
        }
        const result = await requestLogin.action({
          variables: {
            podcastSlug: slug,
            amount,
            email: values.email,
          },
        });
        onContinue(
          result.createSubscriptionCheckoutSession!.nextState.toLowerCase() as Step,
        );
      }}
    >
      <TextInput
        description={<FormattedMessage {...messages.copy} />}
        name="email"
        label={<FormattedMessage {...messages.label} />}
        placeholder="me@example.com"
        type="email"
        validate={required}
        validateOn="blur"
      />
      <Button $isPrimary type="submit" pending={requestLogin.pending}>
        <FormattedMessage {...messages.submit} />
      </Button>
    </Form>
  );
};

export default TipJarRequestLogin;
